// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/ear-anatomy.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/ear-anatomy/ear-anatomy.js';
import g1 from '../lessons/aeronautics/ear-anatomy/hearing-sense-rank.js';

mount([g0, g1]);
